<template>
	<div id="container">
		<div class="search-container">
			<div class="search-input-group">
				<input type="text" v-model="searchLockNo" placeholder="输入车锁编号搜索" class="search-input">
				<button @click="searchLock" class="search-button">搜索</button>
			</div>
		</div>
		<div class="search-tip">如果查询到多个车锁，再次点击搜索跳转下一个车锁位置</div>
		<div id="map_view"></div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			lockDeviceList: [],
			geometrieList: [],
			labelGeometries: [],
			infoWindows: [],
			map: null,
			markerLayer: null,
			labelLayer: null,
			polygonLayer: null,
			searchLockNo: '',
			currentSearchIndex: -1,
			matchingLocks: [],
			electronicFenceList: [],
			fenceGeometrieList: []
		}
	},
	mounted() {
		this.initMap();
		this.getLockDeviceList();
		this.getElectronicFenceList();
	},
	beforeDestroy() {
		if (this.map) {
			this.map.destroy();
			this.map = null;
		}
	},
	methods: {
		initMap() {
			if (this.map) {
				this.map.destroy();
			}
			
			var center = new TMap.LatLng(32.902652, 117.440006)
			this.map = new TMap.Map(document.getElementById('map_view'), {
				center: center,
				zoom: 15
			});
			
			this.markerLayer = new TMap.MultiMarker({
				map: this.map,
				styles: {
					"bicycleStyle": new TMap.MarkerStyle({
						width: 40,
						height: 40,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 20, y: 40 }
					}),
					"electricStyle": new TMap.MarkerStyle({
						width: 40,
						height: 40,
						src: require('@/assets/image/diandongche.png'),
						anchor: { x: 20, y: 40 }
					})
				},
				geometries: []
			});
			
			this.labelLayer = new TMap.MultiLabel({
				map: this.map,
				styles: {
					"labelStyle": new TMap.LabelStyle({
						position: "top",
						offset: { x: 0, y: -50 },
						size: 13,
						color: "#3CA757",
						backgroundColor: "#fff",
						width: 120,
						height: 20,
						borderColor: "#3CA757",
						borderWidth: 1,
						borderRadius: 4,
						padding: 5,
						enableCollision: false
					})
				},
				geometries: []
			});
			
			this.polygonLayer = new TMap.MultiPolygon({
				map: this.map,
				styles: {
					"fenceStyle": new TMap.PolygonStyle({
						color: 'rgba(255, 107, 53, 0.2)',
						showBorder: true,
						borderColor: '#ff6b35',
						borderWidth: 2
					})
				},
				geometries: []
			});
			
			console.log('Map initialized successfully');
			
			// 获取当前位置并设置地图中心
			this.getCurrentLocation();
		},
		getCurrentLocation() {
			// 优先使用腾讯地图定位服务
			if (typeof TMap !== 'undefined' && TMap.service) {
				const geolocation = new TMap.service.Geolocation();
				geolocation.getLocation().then(result => {
					if (result && result.lat && result.lng) {
						const currentCenter = new TMap.LatLng(result.lat, result.lng);
						this.map.setCenter(currentCenter);
						console.log('腾讯地图定位成功:', result.lat, result.lng);
					}
				}).catch(error => {
					console.warn('腾讯地图定位失败，尝试浏览器定位:', error);
					this.getBrowserLocation();
				});
			} else {
				this.getBrowserLocation();
			}
		},
		getBrowserLocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						const lat = position.coords.latitude;
						const lng = position.coords.longitude;
						const currentCenter = new TMap.LatLng(lat, lng);
						this.map.setCenter(currentCenter);
						console.log('浏览器定位成功:', lat, lng);
					},
					(error) => {
						console.warn('浏览器定位失败:', error.message);
					},
					{
						enableHighAccuracy: true,
						timeout: 10000,
						maximumAge: 0
					}
				);
			} else {
				console.warn('浏览器不支持地理定位');
			}
		},
		getLockDeviceList() {
			this.geometrieList = [];
			this.labelGeometries = [];
			
			this.$http.get('/device/manager/getMapLockDevice').then((res) => {
				if (res.data.code == 200) {
					console.log("res: ", res)
					this.lockDeviceList = res.data.data;
					for (let index in this.lockDeviceList) {
						if (this.lockDeviceList[index].longitude == null || this.lockDeviceList[index].latitude == null) {
							continue;
						}
						
						const lockNo = this.lockDeviceList[index].qrNumber || this.lockDeviceList[index].imei || "未知编号";
						const bicycleType = this.lockDeviceList[index].bicycleType || 1;
						const styleId = bicycleType === 2 ? 'electricStyle' : 'bicycleStyle';
						const position = new TMap.LatLng(this.lockDeviceList[index].latitude, this.lockDeviceList[index].longitude);
						
						this.geometrieList.push(
							{
								id: index,
								styleId: styleId,
								position: position,
								properties: {
									title: lockNo,
									lockNo: lockNo
								}
							}
						);
						
						this.labelGeometries.push(
							{
								id: `label_${index}`,
								styleId: 'labelStyle',
								position: position,
								content: lockNo
							}
						);
					}
					
					if (this.markerLayer) {
						this.markerLayer.setGeometries(this.geometrieList);
						console.log('车锁标记添加成功');
					}
					
					if (this.labelLayer) {
						this.labelLayer.setGeometries(this.labelGeometries);
						console.log('车锁编号标签添加成功');
					}
					
					return;
				}
				this.$message.error(res.data.msg)
			})
		},
		getElectronicFenceList() {
			this.$http.get('/device/manager/table/getElectronicFenceList').then((res) => {
				console.log("查询电子围栏：", res);
				if (res.data.code == 200) {
					this.electronicFenceList = res.data.data;
					this.fenceGeometrieList = [];
					
					if (this.electronicFenceList && this.electronicFenceList.length > 0) {
						for (let index in this.electronicFenceList) {
							let fence = this.electronicFenceList[index];
							if (fence.paths && fence.paths.length > 0) {
								let polygonPaths = fence.paths.map(function (point) {
									return new TMap.LatLng(point.lat, point.lng);
								});
								
								this.fenceGeometrieList.push({
									id: `fence_${fence.id || index}`,
									styleId: 'fenceStyle',
									paths: [polygonPaths]
								});
							}
						}
						
						if (this.polygonLayer && this.fenceGeometrieList.length > 0) {
							this.polygonLayer.setGeometries(this.fenceGeometrieList);
							console.log('电子围栏添加成功:', this.fenceGeometrieList);
						}
					}
				}
			})
		},
		searchLock() {
			if (!this.searchLockNo) {
				this.$message.warning('请输入车锁编号');
				return;
			}
			
			this.matchingLocks = this.lockDeviceList.filter(device => {
				if (!device.latitude || !device.longitude) {
					return false;
				}
				const lockNo = device.qrNumber || device.imei || "未知编号";
				return lockNo.includes(this.searchLockNo);
			});
			
			if (this.matchingLocks.length > 0) {
				this.currentSearchIndex = (this.currentSearchIndex + 1) % this.matchingLocks.length;
				const currentLock = this.matchingLocks[this.currentSearchIndex];
				
				const position = new TMap.LatLng(currentLock.latitude, currentLock.longitude);
				this.map.setCenter(position);
				this.map.setZoom(15);
				
				const lockNo = currentLock.qrNumber || currentLock.imei || "未知编号";
				this.$message.success(`找到车锁 ${lockNo}，已定位到地图中心 (${this.currentSearchIndex + 1}/${this.matchingLocks.length})`);
			} else {
				this.currentSearchIndex = -1;
				this.$message.error('未找到匹配的车锁编号');
			}
		}
	},
}
</script>

<style scoped>
#container {
	position: relative;
	width: 100%;
	height: 100vh;
	min-height: 600px;
}

.search-container {
	position: absolute;
	top: 20px;
	left: 20px;
	z-index: 9999;
	background-color: white;
	padding: 10px;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	display: flex;
	align-items: center;
	pointer-events: auto;
}

.search-input-group {
	display: flex;
	align-items: center;
}

.search-tip {
	position: absolute;
	top: 75px;
	left: 20px;
	z-index: 9999;
	font-size: 12px;
	color: #666;
	white-space: nowrap;
	pointer-events: none;
	background-color: rgba(255, 255, 255, 0.9);
	padding: 4px 8px;
	border-radius: 4px;
	box-shadow: 0 1px 3px rgba(85, 84, 84, 0.1);
}

.search-input {
	width: 160px;
	padding: 6px 10px;
	border: 1px solid #ddd;
	border-radius: 4px;
	margin-right: 8px;
	font-size: 12px;
}

.search-button {
	padding: 6px 12px;
	background-color: #3CA757;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 12px;
}

.search-button:hover {
	background-color: #3CA757;
}

#map_view {
	width: 100%;
	height: 100%;
	overflow: hidden;
}
</style>

<style>
.custom-info-window {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

.custom-info-window .tmap-info-window-close {
	display: none !important;
}

.custom-info-window .tmap-info-window-arrow {
	display: none !important;
}

.custom-info-window .tmap-info-window-content {
	background-color: transparent !important;
	border: none !important;
	box-shadow: none !important;
}

.custom-info-window .tmap-info-window-content div {
	padding: 4px 8px !important;
	background-color: white !important;
	border: 1px solid #ff6b35 !important;
	border-radius: 4px !important;
	font-size: 12px !important;
	color: #333 !important;
	white-space: nowrap !important;
}
</style>